import React from 'react';
import { Link } from 'react-router-dom';

// תמונות
import heroImage from '../assets/images/hero-soldering.jpg';
import logo from '../assets/images/logo.svg';
import smt1Image from '../assets/images/smt1.jpg';
import smt2Image from '../assets/images/smt2.jpg';
import smt3Image from '../assets/images/smt3.jpg';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="gradient-primary text-white relative overflow-hidden min-h-[90vh] flex items-center wave-animation">
        <div className="absolute inset-0 pattern-grid"></div>
        <div className="absolute inset-0 bg-primary-900/20"></div>
        {/* תמונת רקע */}
        <div className="absolute inset-0">
          <img 
            src={heroImage} 
            alt="הלחמות מקצועיות" 
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 relative z-10">
          <div className="text-center">
            {/* לוגו */}
            <div className="flex justify-center mb-12 animate-fade-in">
              <img 
                src={logo} 
                alt="D.I.Technologies Logo" 
                className="w-48 h-48 transform hover:scale-105 transition-transform duration-300"
              />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight animate-fade-in">
              פתרונות הלחמה <br/> 
              <span className="text-gradient bg-gradient-to-r from-white to-primary-200">
                מקצועיים ומדויקים
              </span>
            </h1>
            <p className="text-2xl md:text-3xl mb-12 text-primary-100 max-w-3xl mx-auto font-light animate-fade-in" style={{animationDelay: '0.2s'}}>
              שירותי הלחמה מתקדמים לרכיבי SMT, BGA ועבודות מיקרו-אלקטרוניקה ברמה הגבוהה ביותר
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6 animate-fade-in" style={{animationDelay: '0.4s'}}>
              <Link to="/contact" className="hero-button bg-white text-primary-600 hover:bg-primary-50 hover-glow">
                צור קשר עכשיו
              </Link>
              <Link to="/services" className="hero-button bg-transparent border-2 border-white hover:bg-white/10">
                לכל השירותים
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="section-title">למה לבחור בנו?</h2>
            <p className="section-description">
              אנו מספקים פתרונות הלחמה מתקדמים עם ציוד מתקדם וצוות מקצועי ומנוסה
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="feature-card floating-animation" style={{animationDelay: '0s'}}>
              <div className="relative mb-8 overflow-hidden rounded-xl">
                <img 
                  src={smt1Image} 
                  alt="הלחמות SMT/BGA" 
                  className="w-full h-48 object-cover transform transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute inset-0 bg-primary-600/0 hover:bg-primary-600/10 transition-colors duration-300"></div>
              </div>
              <div className="icon-container mb-6 pulse-animation">
                <svg className="feature-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">הלחמות מתקדמות</h3>
              <p className="text-gray-600 leading-relaxed text-lg">הלחמות SMT, TH, FINE PITCH ו-BGA ברמה אזרחית וצבאית, כולל עבודה תחת מיקרוסקופ</p>
            </div>

            <div className="feature-card floating-animation" style={{animationDelay: '0.2s'}}>
              <div className="relative mb-8 overflow-hidden rounded-xl">
                <img 
                  src={smt2Image} 
                  alt="עבודה מדויקת" 
                  className="w-full h-48 object-cover transform transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute inset-0 bg-primary-600/0 hover:bg-primary-600/10 transition-colors duration-300"></div>
              </div>
              <div className="icon-container mb-6 pulse-animation">
                <svg className="feature-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">פיתוח ותיעוד</h3>
              <p className="text-gray-600 leading-relaxed text-lg">הרכבת מעגלי PROTOTYPE, עבודה מול מחלקות פיתוח והכנת תיעוד מפורט לייצור</p>
            </div>

            <div className="feature-card floating-animation" style={{animationDelay: '0.4s'}}>
              <div className="relative mb-8 overflow-hidden rounded-xl">
                <img 
                  src={smt3Image} 
                  alt="שירות מקצועי" 
                  className="w-full h-48 object-cover transform transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute inset-0 bg-primary-600/0 hover:bg-primary-600/10 transition-colors duration-300"></div>
              </div>
              <div className="icon-container mb-6 pulse-animation">
                <svg className="feature-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">גמישות מקסימלית</h3>
              <p className="text-gray-600 leading-relaxed text-lg">שירות בבית הלקוח או במעבדה, כולל עבודות דחופות ופרויקטים מורכבים</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="gradient-primary py-32 relative overflow-hidden wave-animation">
        <div className="absolute inset-0 pattern-grid"></div>
        <div className="absolute inset-0 bg-primary-900/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 animate-fade-in">מחפשים פתרון מקצועי?</h2>
            <p className="text-xl md:text-2xl text-primary-100 mb-12 font-light animate-fade-in" style={{animationDelay: '0.2s'}}>
              אנחנו כאן לעזור לכם עם כל סוגי ההלחמות, החיווט והפיתוח
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6 animate-fade-in" style={{animationDelay: '0.4s'}}>
              <Link to="/services" className="hero-button bg-white text-primary-600 hover:bg-primary-50 hover-glow">
                לכל השירותים
              </Link>
              <Link to="/contact" className="hero-button bg-transparent border-2 border-white hover:bg-white/10">
                דברו איתנו
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 